// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__xTnIT","modal":"Modal_modal__DJDMv","content":"Modal_content__gGb69","closeButton":"Modal_closeButton__Ya+Ev"};